import type { SceneConfig } from './sceneConfig';
import { ARAFAT_DEFAULT_COLLIDERS } from './collision/arafatColliders';
import { resolveCdnUrl } from '../utils/cdnUrl';

const ARAFAT_2M_URL = resolveCdnUrl('models/arafat/Arafat_2M.sog');
const ARAFAT_1M_URL = resolveCdnUrl('models/arafat/Arafat_1M.sog');
const ARAFAT_600K_URL = resolveCdnUrl('models/arafat/Arafat_600K.sog');

export const arafatSceneConfig: SceneConfig = {
  id: 'arafat',
  renderer: {
    clearColor: 0x0f0f13,
  },
  camera: {
    fov: 60,
    near: 0.01,
    far: 1e4,
    initialPosition: {
      "x": -0.368,
      "y": 0.348,
      "z": 1.486
    },
    previewTourStart: { x: -0.8, y: -0.08, z: 3.21 },
    previewTourEnd: {
      "position": { x: 0.38, y: -0.9, z: 3.54 },
      "target": {
        "x": -0.01,
        "y": -0.45,
        "z": -0.02
      }
    },

    flyover: {
      delay: 0.8,
      segments: [
        { type: 'waypoint', position: { x: 0.3, y: 0.55, z: 3.57 }, target: { x: -0.01, y: -0.45, z: -0.02 }, duration: 1 },
        { type: 'orbit', center: { x: -0.01, y: -0.45, z: -0.02 }, radius: 3.603, height: 1.0, angleDeg: 360, duration: 6 },
        { type: 'waypoint', position: {
            "x": -0.801,
            "y": 0.012,
            "z": 4.146
          }, target: { x: -0.01, y: -0.45, z: -0.02 }, duration: 1 },
      ],
    },

    // Authored in the FlyoverTuner (?flight): sweep in from the side along
    // the ridge → push toward the Jabal al-Rahmah pillar → lift and turn
    // to reveal the Arafat valley. All look at the base pivot.
    // flyover: {
    //   delay: 0.5,
    //   segments: [
    //     { type: 'waypoint', position: { x: -4.248, y: 0.012, z: 0.128 }, target: { x: -0.01, y: -0.45, z: -0.02 }, duration: 2 },
    //     { type: 'waypoint', position: { x: -2.357, y: -0.194, z: 0.062 }, target: { x: -0.01, y: -0.45, z: -0.02 }, duration: 2 },
    //     { type: 'waypoint', position: { x: -2.173, y: 0.3, z: -2.465 }, target: { x: -0.01, y: -0.45, z: -0.02 }, duration: 2 },
    //   ],
    // },
  },
  poi: {
    clusterEnabled: false,
  },
  controls: {
    orbitMinDistance: 0,
    orbitMaxDistance: 10000,
    clampMinHeight: -1.7,
    clampMaxHeight: Infinity,
    clampMaxHeightFar: Infinity,
    orbitMinPolarAngle: (70 / 180) * Math.PI,
    orbitMaxPolarAngle: Math.PI,
    constrainVertical: false,
    orbitCenter: { x: -0.01, y: -0.45, z: -0.02 },
  },
  colliders: ARAFAT_DEFAULT_COLLIDERS,
  splat: {
    defaultByQuality: {
      desktop: 'arafat_2m',
      mobile: {
        high: 'arafat_1m',
        middle: 'arafat_1m',
        low: 'arafat_600k',
      },
    },
    variants: [
      {
        key: 'arafat_2m',
        url: ARAFAT_2M_URL,
      },
      {
        key: 'arafat_1m',
        url: ARAFAT_1M_URL,
      },
      {
        key: 'arafat_600k',
        url: ARAFAT_600K_URL,
      },
    ],
    defaultTransform: {
      rotation: { x: Math.PI, y: Math.PI, z: 0 },
    },
    revealAnimationDuration: 3.5,
    revealDistanceScale: 1.5,
    revealMode: '3d',
    revealOrigin: { x: -0.01, y: -0.45, z: -0.02 },
  },
  previewModel: {
    url: resolveCdnUrl('preview/Arafat_preloader_v2_pnts_150000_meshopt(16).glb'),
    style: {
      // Match pre_loader_II baseline (~3px on-screen). Без этого
      // gl_PointSize = sizeFromMat(1) × default(1) = 1px → бледно на retina.
      pointSizeFactor: 3.0,
      wavesCenter: { x: 0, y: 0, z: 0 },
      wavesAmplitude: 2.0,
      wavesPeriod: 1.0,
      wavesSpeed: 1.5,
      wavesColorIntensity: 5.0,
      wavesDisplacement: 0.02,
    },
  },
  assistant: {
    position: { x: 0, y: 0, z: -0.03 },
    rotationY: 0,
    scale: 0.0000625,
    reflectionResolution: 128,
  },
  environment: {
    hemisphereLight: {
      skyColor: 0xffffff,
      groundColor: 0x444444,
      intensity: 0.6,
    },
    directionalLights: [
      {
        color: 0xffffff,
        intensity: 1.0,
        position: { x: 50, y: 100, z: 50 },
      },
    ],
    background: {
      color: 0x0f0f13,
      skybox: {
        url: resolveCdnUrl('environment/autumn_field_puresky_8k.jpg'),
        mobileUrl: resolveCdnUrl('environment/autumn_field_puresky_2k.jpg'),
        intensity: 1.0,
        blur: 0.0,
        rotation: [0, 205, 0]
      }
    },
  },
  virtualTour: [],
};
